import React from 'react';
import { motion } from 'framer-motion';
import { 
  Cloud, 
  Network, 
  Terminal, 
  Server, 
  FileCode, 
  CloudCog, 
  Mail, 
  Shield, 
  Wifi, 
  Video, 
  Headset, 
  AlertCircle, 
  HardDrive, 
  Database, 
  Cpu, 
  Wrench 
} from 'lucide-react';

const iconMap = {
  'AWS': Cloud,
  'Networking': Network,
  'Linux': Terminal,
  'Windows Server': Server,
  'Cloud Computing': CloudCog,
  'Office 365': Mail,
  'Azure AD': Shield,
  'Python': FileCode,
  'Wireless Networking': Wifi,
  'Video Surveillance': Video,
  'Technical Support': Headset,
  'Incident Management': AlertCircle,
  'IT Infrastructure': HardDrive,
  'Storage Systems': Database,
  'Computer Hardware': Cpu,
  'Troubleshooting': Wrench
};

const SkillIcon = ({ skill, index }) => {
  const Icon = iconMap[skill.name] || Code;

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.8 }}
      whileInView={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.5, delay: index * 0.05 }}
      viewport={{ once: true }}
      className="flex flex-col items-center"
    >
      <motion.div
        whileHover={{ scale: 1.1, rotate: 5 }}
        className="w-20 h-20 bg-slate-800 border-2 border-blue-500 rounded-lg flex items-center justify-center mb-3 hover:bg-slate-700 transition-all"
      >
        <Icon className="w-10 h-10 text-blue-400" />
      </motion.div>
      <h3 className="text-sm font-semibold text-white text-center leading-tight h-10 flex items-center justify-center">{skill.name}</h3>
    </motion.div>
  );
};

export default SkillIcon;